// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Co7r","consentsList":"PatientConsents_consentsList__-v0UI","consentsListEmpty":"PatientConsents_consentsListEmpty__33qx4"};